export default __webpack_public_path__ + "static/media/9.4fddaa5c.jpg";